import { Radio } from 'antd';
import { Controller, useFormContext } from 'react-hook-form';

import ArrayField from '../../../common/components/Fields/ArrayField';
import TextField from '../../../common/components/Fields/TextField';
import {
  SellerEmailGraphqlInputType,
  UpdateSellerEmailGraphqlInput,
} from '../../../schema/types';
import { SELLER_EMAILS_MAX_LENGTH } from '../const';

import ItemDeleteButton from './ItemDeleteButton';

type EmailsFormValue = {
  emails: UpdateSellerEmailGraphqlInput[] | SellerEmailGraphqlInputType[];
};

type EmailsFieldProps = {
  disabled: boolean;
};

function EmailsField({ disabled }: EmailsFieldProps) {
  const { control, formState, setValue, watch } =
    useFormContext<EmailsFormValue>();

  const emails = watch('emails');

  return (
    <ArrayField
      name={'emails'}
      control={control}
      label={'이메일주소'}
      maxLength={SELLER_EMAILS_MAX_LENGTH}
      disabled={disabled}
      addButtonProps={{
        onClick: ({ append, fields }) => {
          append(
            { email: '', isDefault: false },
            { focusName: `emails.${fields.length}.email` }
          );
        },
      }}
    >
      {({ fields, remove, update }) => {
        return (
          <div className={'mb-md grid gap-md'}>
            {fields.map((field, index) => {
              const errors = formState.errors?.emails?.[index];
              const email = emails[index];

              return (
                <div
                  key={field.key}
                  className={`grid gap-md ${
                    fields.length > 1
                      ? 'grid-cols-textArrayField'
                      : 'grid-cols-1'
                  }`}
                >
                  <TextField
                    disabled={disabled}
                    name={`emails.${index}.email`}
                    control={control}
                    placeholder={'info@wired.company'}
                  />

                  {fields.length > 1 && (
                    <div className={'flex h-xxl items-center gap-md'}>
                      {!disabled && (
                        <ItemDeleteButton
                          disabled={fields.length === 0}
                          onClick={() => {
                            if (email.isDefault) {
                              const target = index === 0 ? 1 : index - 1;

                              update(target, {
                                ...emails[target],
                                isDefault: true,
                              });
                            }
                            remove(index);
                          }}
                        />
                      )}

                      <Controller
                        render={({ field: controllerField }) => (
                          <Radio
                            name={controllerField.name}
                            checked={controllerField.value as boolean}
                            className={'whitespace-nowrap'}
                            disabled={!email.email || !!errors || disabled}
                            onChange={() => {
                              setValue(
                                'emails',
                                fields.map((eachField, index) => ({
                                  ...emails?.[index],
                                  isDefault: eachField.key === field.key,
                                })),
                                {
                                  shouldTouch: true,
                                  shouldValidate: true,
                                  shouldDirty: true,
                                }
                              );
                            }}
                          >
                            대표
                          </Radio>
                        )}
                        name={`emails.${index}.isDefault`}
                      />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        );
      }}
    </ArrayField>
  );
}

export default EmailsField;
